





















































































































































































































































































































































































































































import { Component, Vue, PropSync, Ref, Watch, Prop } from "vue-property-decorator";
import store from "@/store";
import conditionTypeHelper from "Utilities/condition-type-helper";
import htmlEncoder from "Utilities/htmlencode-helper";
// types
import { Channel, Condition } from "@/types/condition";
import { UserProfile } from "@/types/userProfile";
// components
import ConfirmDialog from "@/components/ConfirmDialog.vue";
// modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import UsersModule from "@/store/clients/Users.module";
import UserModule from "@/store/clients/User.module";
import ChannelsModule from "@/store/clients/Channels.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const Vessels = getModule(VesselsModule, store);
const Users = getModule(UsersModule, store);
const User = getModule(UserModule, store);
const Channels = getModule(ChannelsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class CustomRecipientItem extends Vue {
  @PropSync("condition", { required: true }) syncCondition!: Condition;
  @PropSync("recipients", { required: true }) syncRecipients!: Channel[];
  @Prop({ required: true, default: false }) isSameRecipients!: boolean;
  @Ref("confirmDelete") confirmDelete!: any;
  // @Watchers
  @Watch("syncCondition", { deep: true })
  onSyncConditionUpdate(): void {
    this.selectedRecipients = (this.syncCondition.channels || []).map(ch => this.syncRecipients.find(r => (ch.userId && r.userId === ch.userId) || (!ch.userId && r.email === ch.email)) || ch);
  }
  // @Data
  RecipientsSelectMenu = false;
  addNewRecipientInput = false;
  searchRecipientQuery: string = "";
  selectedRecipients: Channel[] = [];
  newCustomEmail: string | null = null;
  emailRules = {
    valid: (value: string) => (/^([\w\.\-\+]+)@([\w\-]+)((\.(\w){2,6})+)$/.test(value) && value.length) || value == null || "Email must be valid",
  };

  // @Getters
  get myUserProfile(): UserProfile | null {
    return User.userProfile;
  }
  get isAssignToMeAvailable(): boolean {
    return !!this.myUserProfile && this.syncRecipients.some(r => r.userId === (this.myUserProfile ? this.myUserProfile.id : undefined));
  }
  get getConditionTypeText(): string {
    return conditionTypeHelper.getConditionTypeText(this.syncCondition);
  }

  get isEmailValid(): boolean {
    if (typeof this.emailRules.valid(this.newCustomEmail ?? "") === "string") return true;
    return false;
  }

  get vesselName(): string {
    const vessel = Vessels.getExtendedVesselById(this.syncCondition.vesselId);
    return vessel ? vessel.name : "";
  }

  get users(): UserProfile[] {
    return Users.users;
  }

  get isAllRecipientsSelected(): boolean {
    return this.selectedRecipients.length === this.syncRecipients.length;
  }

  get isDisplayed(): boolean {
    const vessel = Vessels.getExtendedVesselById(this.syncCondition.vesselId);
    if (!vessel) return false;
    if (this.syncCondition.conditionType === "PerformanceStatusObserve" || this.syncCondition.conditionType === "PerformanceStatusNotOk") {
      return vessel.features.some(f => f.name === "Diagnostics");
    } else if (this.syncCondition.conditionType === "ShapoliPowerReserveBreach") {
      return vessel.features.some(f => f.name === "Shapoli");
    } else {
      return true;
    }
  }

  get selectedUsers(): Channel[] {
    return this.selectedRecipients.filter(r => r.userId);
  }

  get selectedChannels(): Channel[] {
    return this.selectedRecipients.filter(r => r.userId === null);
  }

  get formattedSelectionResult(): string {
    const isAllSelected = this.selectedRecipients.length === this.syncRecipients.length && this.syncRecipients.length > 0;

    let result = [];
    if (this.selectedUsers.length > 0) result.push(`Users (${this.selectedUsers.length})`);
    if (this.selectedChannels.length > 0) result.push(`Recipients (${this.selectedChannels.length})`);
    if (isAllSelected) result = [`All (${this.selectedUsers.length + this.selectedChannels.length})`];

    return result.join(", ");
  }

  // @Methods
  userName(userId: string): string {
    const user = Users.getUserById(userId);
    return user?.name ? user.name : `Not specified`;
  }

  submitEmail(): void {
    Channels.ADD_CHANNEL({ email: this.newCustomEmail, userId: null });
    this.newCustomEmail = null;
    this.addNewRecipientInput = false;
  }

  async deleteMail(channel: Channel): Promise<void> {
    const confirmed = await this.confirmDelete.open(
      "Delete saved email from all conditions?",
      "Are you sure you want to delete this email? It will instantly be removed from all alerts on all vessels using it, not only this one."
    );

    if (!confirmed) return;
    try {
      if (channel.id) await Channels.deleteChannel(channel.id);
      const chnlIndex = this.syncRecipients.findIndex(chnl => channel.email === chnl.email);
      if (chnlIndex !== -1) this.syncRecipients.splice(chnlIndex, 1);
      Channels.DELETE_CHANNEL(channel);
      Snackbar.showSnackbar({
        text: `Recipient email <b>'${htmlEncoder.htmlEncode(channel.email)}'</b> was successfully <b>deleted</b>`,
        color: "success",
      });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to delete channel" });
    }
  }

  assignToMe(): void {
    if (!this.myUserProfile) return;
    const alreadyAssigned = this.selectedRecipients.some(r => r.userId === this.myUserProfile!.id);
    if (!alreadyAssigned) {
      const userRecipient = this.syncRecipients.find(r => r.userId === this.myUserProfile!.id);
      if (userRecipient) {
        this.selectedRecipients.push(userRecipient);
        this.onRecipientsChanged();
      }
    }
  }

  onRemoveRecipient(channel: Channel): void {
    this.selectedRecipients = this.selectedRecipients.filter(chnl => chnl.email !== channel.email);
    this.onRecipientsChanged();
  }

  onSelectAll($event: boolean): void {
    this.selectedRecipients = $event ? [...this.syncRecipients] : [];
    this.onRecipientsChanged();
  }

  onRecipientsChanged(): void {
    this.$emit("update", { vesselId: this.syncCondition.vesselId, conditionType: this.syncCondition.conditionType, channels: this.selectedRecipients, isSameRecipients: this.isSameRecipients });
  }

  // @Hooks
  created(): void {
    this.selectedRecipients = (this.syncCondition.channels || []).map(ch => this.syncRecipients.find(r => (ch.userId && r.userId === ch.userId) || (!ch.userId && r.email === ch.email)) || ch);
  }
}
